import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import './slider.scss'
import './sections/slider.scss'

function Sliders() {
    let settings = {
        dot:true,
        infinite:true,
        speed:500,
        slidesToShow:3,
        slidesToScroll:1,
        caseEase: 'linear'
    }
    return (
        <Slider {...settings} className='slider-body'>
            <div className='card-wrapper'>
                <div className='card'>
                    <div className='card-image'>
                        <img src={require('./../assets/images/carpenter.jpeg')} />
                    </div>
                    {/* <ul className='social-icons'>
                        <li>
                            <a href="#">
                                <i className="fab fa-facebook-f"></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-instagram'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-twitter'></i>
                            </a>
                        </li>
                    </ul> */}
                    <div>
                        <h2 className='details'>Carpenter <span className='job-title'>Carpenter</span></h2>
                    </div>
                </div>
            </div>
            <div className='card-wrapper'>
                <div className='card'>
                    <div className='card-image'>
                        <img src={require('./../assets/images/electrician.jpeg')} />
                    </div>
                    {/* <ul className='social-icons'>
                        <li>
                            <a href="#">
                                <i class='fa fa-facebook'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-instagram'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-twitter'></i>
                            </a>
                        </li>
                    </ul> */}
                    <div>
                        <h2 className='details'>Electrician <span className='job-title'>Electrician</span></h2>
                    </div>
                </div>
            </div>
            <div className='card-wrapper'>
                <div className='card'>
                    <div className='card-image'>
                        <img src={require('./../assets/images/houseclean.jpeg')} />
                    </div>
                    {/* <ul className='social-icons'>
                        <li>
                            <a href="#">
                                <i class='fa fa-facebook'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-instagram'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-twitter'></i>
                            </a>
                        </li>
                    </ul> */}
                    <div>
                        <h2 className='details'>House Cleaning <span className='job-title'>House Cleaning</span></h2>
                    </div>
                </div>
            </div>
            <div className='card-wrapper'>
                <div className='card'>
                    <div className='card-image'>
                        <img src={require('./../assets/images/interior.jpeg')} />
                    </div>
                    {/* <ul className='social-icons'>
                        <li>
                            <a href="#">
                                <i class='fa fa-facebook'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-instagram'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-twitter'></i>
                            </a>
                        </li>
                    </ul> */}
                    <div>
                        <h2 className='details'>Interior Design <span className='job-title'>Interior Design</span></h2>
                    </div>
                </div>
            </div>
            <div className='card-wrapper'>
                <div className='card'>
                    <div className='card-image'>
                        <img src={require('./../assets/images/painter.jpeg')} />
                    </div>
                    {/* <ul className='social-icons'>
                        <li>
                            <a href="#">
                                <i class='fa fa-facebook'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-instagram'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-twitter'></i>
                            </a>
                        </li>
                    </ul> */}
                    <div>
                        <h2 className='details'>Painter <span className='job-title'>Painter</span></h2>
                    </div>
                </div>
            </div>
            <div className='card-wrapper'>
                <div className='card'>
                    <div className='card-image'>
                        <img src={require('./../assets/images/plumber.jpeg')} />
                    </div>
                    {/* <ul className='social-icons'>
                        <li>
                            <a href="#">
                                <i class='fa fa-facebook'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-instagram'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-twitter'></i>
                            </a>
                        </li>
                    </ul> */}
                    <div>
                        <h2 className='details'>Plumber <span className='job-title'>Plumber</span></h2>
                    </div>
                </div>
            </div>
            <div className='card-wrapper'>
                <div className='card'>
                    <div className='card-image'>
                        <img src={require('./../assets/images/pop.jpeg')} />
                    </div>
                   {/* <ul className='social-icons'>
                        <li>
                            <a href="#">
                                <i class='fa fa-facebook'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-instagram'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-twitter'></i>
                            </a>
                        </li>
                    </ul> */}
                    <div>
                        <h2 className='details'>POP <span className='job-title'>POP</span></h2>
                    </div>
                </div>
            </div>
            <div className='card-wrapper'>
                <div className='card'>
                    <div className='card-image'>
                        <img src={require('./../assets/images/renovation.jpeg')} />
                    </div>
                    {/* <ul className='social-icons'>
                        <li>
                            <a href="#">
                                <i class='fa fa-facebook'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-instagram'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-twitter'></i>
                            </a>
                        </li>
                    </ul> */}
                    <div>
                        <h2 className='details'>Renovations <span className='job-title'>Renovations</span></h2>
                    </div>
                </div>
            </div>
            <div className='card-wrapper'>
                <div className='card'>
                    <div className='card-image'>
                        <img src={require('./../assets/images/tiler.jpeg')} />
                    </div>
                    {/* <ul className='social-icons'>
                        <li>
                            <a href="#">
                                <i class='fa fa-facebook'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-instagram'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-twitter'></i>
                            </a>
                        </li>
                    </ul> */}
                    <div>
                        <h2 className='details'>Tiler <span className='job-title'>Tiler</span></h2>
                    </div>
                </div>
            </div>
            <div className='card-wrapper'>
                <div className='card'>
                    <div className='card-image'>
                        <img src={require('./../assets/images/tvrepair.jpeg')} />
                    </div>
                    {/* <ul className='social-icons'>
                        <li>
                            <a href="#">
                                <i class='fa fa-facebook'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-instagram'></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class='fa fa-twitter'></i>
                            </a>
                        </li>
                    </ul> */}
                    <div>
                        <h2 className='details'>TV Repairs <span className='job-title'>TV Repairs</span></h2>
                    </div>
                </div>
            </div>
        </Slider>
    )
}

export default Sliders
